export const openCatalog = ( event, fetchCatalogUrl ) => {
    if ( event && event.preventDefault ) {
        event.preventDefault();
    }
    fetchCatalogUrl()
        .then( catalogUrl => {
            const win = window.open( catalogUrl, '_blank' );
            win.focus();
        } )
        .catch( error => {
            throw error;
        } );
};
